import {OperatingSystemType} from '@toolify/server/src/controllers/NativeAppController/enum/OperatingSystemType'
import {IOperatingSystemTypeInterfacesMap} from '@toolify/server/src/services/OperatingSystemService/types/IOperatingSystemTypeInterfacesMap'
import {useMobileNotificationsStore} from '@toolify/client/src/stores/MobileNotificationsStore/useMobileNotificationsStore'
import {useOperatingSystem} from './useOperatingSystem'

export function useOperatingSystemData() {
  const mobileNotificationsStore = useMobileNotificationsStore()
  const {getOperatingSystem} = useOperatingSystem()
  
  function getOperatingSystemData(): IOperatingSystemTypeInterfacesMap[OperatingSystemType]['payload'] {
    const operatingSystemType = getOperatingSystem()
    if (!operatingSystemType) {
      return null
    }
    if (operatingSystemType === OperatingSystemType.IOs || operatingSystemType === OperatingSystemType.Android) {
      if (mobileNotificationsStore.currentDeviceToken) {
        return { 
          deviceToken: mobileNotificationsStore.currentDeviceToken, 
        }
      }
    }
    return null
  }

  return {
    getOperatingSystemData,
  }
}
